import { render } from "./Attivita.vue?vue&type=template&id=79485558&scoped=true"
import script from "./Attivita.vue?vue&type=script&lang=js"
export * from "./Attivita.vue?vue&type=script&lang=js"

import "./Attivita.vue?vue&type=style&index=0&id=79485558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79485558"]])

export default __exports__